export * from './catalog.component.route';
export { catalogRoute as CatalogRouteModule } from './catalog.component.route';

export * from './catalog.component.route';
export { shoppingCartRoute as shoppingCartRouteModule } from './catalog.component.route';

export * from './catalog.component.store';
export { default as CatalogStoreModule } from './catalog.component.store';
